import { render, staticRenderFns } from "./ContentRecipe.vue?vue&type=template&id=920f59f6"
import script from "./ContentRecipe.vue?vue&type=script&lang=ts"
export * from "./ContentRecipe.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports